import { Component, Input, OnInit } from '@angular/core';
import { SharedService } from '../../../../../shared/shared.service';

@Component({
  selector: 'app-guest-carousel',
  templateUrl: './guest-carousel.component.html',
  styleUrl: './guest-carousel.component.less'
})
export class GuestCarouselComponent implements OnInit {

  @Input() landingCMSData: any;
  containerHeight: number = 585;
  carouselOptions = {
    loop: true,           // Disable looping if needed
    nav: false,             // Show next/previous navigation buttons
    dots: true,            // Show dot indicators for carousel navigation
    autoplay: true,
    responsive: {
      900: {
        items: 1          // Display 3 cards on large screens (desktop)
      }
    }
  };
  cardList: any = [];

  constructor(
    private sharedService: SharedService,
  ) {}


  ngOnInit(): void {
    this.landingCMSData.guestCarouselData.forEach((element: any) => {
      this.cardList.push(element);
    });
  }

  ngAfterViewInit(): void {
    setTimeout(()=>{
      this.sharedService.toggleGlobalLoader(true);
      let carouselElement = document.getElementById('carousel');
      if(carouselElement){
        this.containerHeight = carouselElement.clientHeight;
        this.sharedService.toggleGlobalLoader(false);
      }
    },100)
  }
}
